/**
 * Material Snapshot Utilities
 * Capture dan restore material state untuk undo/redo system
 */

/**
 * Capture complete material state untuk snapshot
 */
export function captureMaterialSnapshot(material) {
  if (!material) return null

  const snapshot = {
    // Material type
    type: material.type,

    // Colors as HEX CODE (exact, reliable)
    colorHex: material.color
      ? `#${material.color.getHexString()}`
      : null,
    emissiveHex: material.emissive
      ? `#${material.emissive.getHexString()}`
      : null,

    // Properties as EXACT VALUES
    metalness:
      material.metalness !== undefined
        ? Number(material.metalness)
        : null,
    roughness:
      material.roughness !== undefined
        ? Number(material.roughness)
        : null,
    opacity:
      material.opacity !== undefined
        ? Number(material.opacity)
        : null,
    transparent: Boolean(material.transparent),
    wireframe: Boolean(material.wireframe),
    emissiveIntensity:
      material.emissiveIntensity !== undefined
        ? Number(material.emissiveIntensity)
        : null,
    side: material.side,

    // Material reference (untuk restore nanti)
    _materialRef: material,

    // Metadata
    _timestamp: Date.now(),
  }

  return snapshot
}

/**
 * Restore material dari snapshot dengan EXACT VALUES
 */
export function restoreMaterialSnapshot(snapshot) {
  if (!snapshot || !snapshot._materialRef) return false

  const material = snapshot._materialRef

  // Restore colors from HEX CODE (exact!)
  if (snapshot.colorHex && material.color) {
    material.color.set(snapshot.colorHex)
  }

  if (snapshot.emissiveHex && material.emissive) {
    material.emissive.set(snapshot.emissiveHex)
  }

  // Restore EXACT slider values
  if (snapshot.metalness !== null && snapshot.metalness !== undefined) {
    material.metalness = snapshot.metalness
  }

  if (snapshot.roughness !== null && snapshot.roughness !== undefined) {
    material.roughness = snapshot.roughness
  }

  if (snapshot.opacity !== null && snapshot.opacity !== undefined) {
    material.opacity = snapshot.opacity
    material.transparent = snapshot.transparent
  }

  if (snapshot.wireframe !== null && snapshot.wireframe !== undefined) {
    material.wireframe = snapshot.wireframe
  }

  if (
    snapshot.emissiveIntensity !== null &&
    snapshot.emissiveIntensity !== undefined
  ) {
    material.emissiveIntensity = snapshot.emissiveIntensity
  }

  if (snapshot.side !== null && snapshot.side !== undefined) {
    material.side = snapshot.side
  }

  material.needsUpdate = true
  return true
}

